import {Router} from "@angular/router";
import {MixinConstructor} from "./mixin.define";


type ProgressbarMixinType = {
  // 파라미터 없음.
}

export const progressbarMixin = ProgressbarMixinFunction(
  class Parent {
    constructor(
      // 파라미터 없음.
    ) {
    }
  }
)

export function ProgressbarMixinFunction<BaseType extends MixinConstructor>(BaseClass: BaseType) {
  return class extends BaseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    // 프로그래스바 처리 변수
    public pbProgress = 0;
    private _pbInterval: any;
    private _pbTime: number = 0; // 시간 카운터
    private _pbSpeedFactor: number = 10; // 증가 속도 인자 (높을수록 빠름)

    pbInit() {
      // 프로그래스바 처리
      let initialInterval = 300; // 시작 주기 (ms)
      const updateProgress = () => {
        if (this.pbProgress < 99.9) {
          this._pbTime++;
          const increment = (1 / (1 + Math.log1p(this._pbTime))) * this._pbSpeedFactor * (100 - this.pbProgress) / 100;
          const randomFactor = Math.random() * 0.4 + 0.8; // 0.9에서 1.1 사이의 랜덤 인자

          this.pbProgress += increment * randomFactor;

          if (this.pbProgress > 99.9) {
            this.pbProgress = 99.9;
          }

          // 주기는 일정하게 유지하거나 필요하면 조절 가능
          const nextInterval = initialInterval;

          // 다음 업데이트 스케줄
          this._pbInterval = setTimeout(updateProgress, nextInterval);
        }
      };
      this._pbInterval = setTimeout(updateProgress, initialInterval); // 초기 업데이트 스케줄
    }

    pbExit() {
    // 프로그래스바 중지
    if (this._pbInterval) {
        clearTimeout(this._pbInterval);
      }
    }
  }
}

